(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  // fonction pour attendre qu'un element soit chargé
    function waitForElm(selector) {
      return new Promise(resolve => {
        if (document.querySelector(selector)) {
          return resolve(document.querySelector(selector))
        }
  
        const observer = new MutationObserver(mutations => {
          if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
          }
        });
  
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      });
    }

  //j'attend que les options soient bien affichées pour initialisé la barre panier latérale
    waitForElm('.gpo-container').then(() => {
      let liste = document.getElementById('product-page--basket');
      let options = document.getElementsByClassName('gpo-container')[0].querySelectorAll('input');
      let prices = document.getElementsByClassName('addOn');
      Array.from(options).forEach(option => {
        option.addEventListener('change', (e)=>{
          if(option.checked == false){
            Array.from(liste.children).forEach((li, index) => {
              if(index > 0){
                if(/_multiple$/.test(option.getAttribute('data-type'))){
                  if(li.lastElementChild.getAttribute('custom_id') == option.getAttribute('id')){
                    li.remove();
                  }
                }else{
                  if(li.lastElementChild.getAttribute('custom_id') == option.getAttribute('data-name')){
                    li.remove();
                  }
                }
              }
            })
          }else{
            Array.from(liste.children).forEach((li, index) => {
              if(index > 0){
                if(/_multiple$/.test(option.getAttribute('data-type'))){
                  if(li.lastElementChild.getAttribute('custom_id') == option.getAttribute('id')){
                    li.remove();
                  }
                }else{
                  if(li.lastElementChild.getAttribute('custom_id') == option.getAttribute('data-name')){
                    li.remove();
                  }
                }
              }
            })
            let element = document.createElement("li");
            let text_element = document.createElement("p");
            let price_text = '';
            Array.from(prices).forEach(price =>{
              if(price.previousElementSibling.innerText == option.value){
                price_text = price.innerText;
              }
            })
            text_element.innerText = option.value + price_text;
            let delete_element = document.createElement('label')
            delete_element.setAttribute('for', option.getAttribute('id'));
            if(/_multiple$/.test(option.getAttribute('data-type'))){
              delete_element.setAttribute('custom_id', option.getAttribute('id'));
            }else{
              delete_element.setAttribute('custom_id', option.getAttribute('data-name'));
            }
            delete_element.classList.add('suppression_option')
            delete_element.innerHTML = '<!-- License: CC Attribution. Made by tetrisly: https://tetrisly.gumroad.com/l/freeicons -->\
                                        <svg fill="#ff7d24" width="24px" height="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\
                                          <path fill-rule="evenodd" d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M7.29325,7.29325 C7.65417308,6.93232692 8.22044527,6.90456361 8.61296051,7.20996006 L8.70725,7.29325 L12.00025,10.58625 L15.29325,7.29325 C15.68425,6.90225 16.31625,6.90225 16.70725,7.29325 C17.0681731,7.65417308 17.0959364,8.22044527 16.7905399,8.61296051 L16.70725,8.70725 L13.41425,12.00025 L16.70725,15.29325 C17.09825,15.68425 17.09825,16.31625 16.70725,16.70725 C16.51225,16.90225 16.25625,17.00025 16.00025,17.00025 C15.7869167,17.00025 15.5735833,16.9321944 15.3955509,16.796662 L15.29325,16.70725 L12.00025,13.41425 L8.70725,16.70725 C8.51225,16.90225 8.25625,17.00025 8.00025,17.00025 C7.74425,17.00025 7.48825,16.90225 7.29325,16.70725 C6.93232692,16.3463269 6.90456361,15.7800547 7.20996006,15.3875395 L7.29325,15.29325 L10.58625,12.00025 L7.29325,8.70725 C6.90225,8.31625 6.90225,7.68425 7.29325,7.29325 Z"/>\
                                        </svg>'
            element.appendChild(text_element);
            element.appendChild(delete_element);
            liste.appendChild(element);
          }
        })
      })
    });

  let panier_mobile = document.getElementsByClassName('product-page--configuration-column')[0]
  let page_produit = document.getElementsByClassName('product-page--root')[0];
  let options_mobile = document.getElementById('afficher-basket-mobile');

  if(panier_mobile){
    window.addEventListener('scroll', ()=>{
      if(window.innerWidth < 767){
        if(scrollY > page_produit.offsetTop){
          panier_mobile.style.display = 'flex';
          panier_mobile.style.top = String(document.getElementsByClassName('header--root')[0].clientHeight)+'px';
          options_mobile.checked = false;
        }
        else{
          panier_mobile.style.display = 'none';
        }
      }
    })
  }
  

  } catch(e) { console.error(e); }
})();
})();
